var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstantAmortization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 120,
    viewBox: "0 0 285 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_15145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 60H60V116C60 118.209 58.2091 120 56 120H4C1.79086 120 0 118.209 0 116V60Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H56C58.2091 0 60 1.79086 60 4V60H0V4Z",
    fill: "#4B2CE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 22.2656V36.4062H26.4688V22.2656H28.2188ZM16.9219 28.2812C16.9141 25.2344 18.4688 23.2969 20.6094 23.2969C22.7266 23.2969 24.2891 25.2344 24.2969 28.2812C24.2891 31.3516 22.7266 33.2812 20.6094 33.2812C18.4688 33.2812 16.9141 31.3516 16.9219 28.2812ZM18.5938 28.2812C18.5938 30.4531 19.4141 31.7109 20.6094 31.7188C21.7969 31.7109 22.6094 30.4531 22.6094 28.2812C22.6094 26.125 21.7969 24.8594 20.6094 24.8594C19.4141 24.8594 18.5938 26.125 18.5938 28.2812ZM35.3594 26.2812C35.3516 28.4609 36.6641 30.9453 38.8906 31.9844L37.9219 33.3594C36.3281 32.6094 35.1484 31.0938 34.5156 29.3281C33.875 31.2656 32.6406 32.9219 31.0156 33.7031L30 32.3438C32.25 31.2734 33.6172 28.6328 33.625 26.2812V25.0938H30.5469V23.6562H38.3125V25.0938H35.3594V26.2812ZM39.625 36.3906V22.2656H41.3594V27.7656H43.5312V29.2188H41.3594V36.3906H39.625Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 82.2812V92.9688H26.5625V91.7344H23.7969V90.5156H26.5625V82.2812H28.3125ZM16.4062 88.625C19.0078 88.6094 22.5156 88.5859 25.5156 88.2031L25.6094 89.4531C24.4453 89.6484 23.2422 89.7734 22.0469 89.8594V92.5781H20.3125V89.9531C18.9922 90.0078 17.7344 90.0156 16.625 90.0156L16.4062 88.625ZM17.4844 85.2969C17.4844 83.8047 18.9219 82.7891 21.0156 82.7969C23.0703 82.7891 24.5156 83.8047 24.5312 85.2969C24.5156 86.8125 23.0703 87.7734 21.0156 87.7812C18.9219 87.7734 17.4844 86.8125 17.4844 85.2969ZM18.2812 96.1094V91.9375H20.0156V94.7031H28.6406V96.1094H18.2812ZM19.125 85.2969C19.125 86.0625 19.8828 86.5078 21.0156 86.5156C22.0938 86.5078 22.8672 86.0625 22.875 85.2969C22.8672 84.5312 22.0938 84.0703 21.0156 84.0781C19.8828 84.0703 19.125 84.5312 19.125 85.2969ZM41.625 82.9531V84.0469C41.6328 85.1484 41.6328 86.3984 41.2812 88.0625H43.2031V89.4688H30.2969V88.0625H39.5234C39.8594 86.5312 39.8906 85.375 39.8906 84.3438H31.8906V82.9531H41.625ZM31.8438 96.2188V91.1094H41.6094V96.2188H31.8438ZM33.5469 94.8125H39.8906V92.4688H33.5469V94.8125Z",
    fill: "#4B2CE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_316_15145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    transform: "translate(75)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 50H135V116C135 118.209 133.209 120 131 120H79C76.7909 120 75 118.209 75 116V50Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 4C75 1.79086 76.7909 0 79 0H131C133.209 0 135 1.79086 135 4V50H75V4Z",
    fill: "#4B2CE8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_316_15145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    transform: "translate(150)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 40H210V116C210 118.209 208.209 120 206 120H154C151.791 120 150 118.209 150 116V40Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 4C150 1.79086 151.791 0 154 0H206C208.209 0 210 1.79086 210 4V40H150V4Z",
    fill: "#4B2CE8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_316_15145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    transform: "translate(225)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 30H285V116C285 118.209 283.209 120 281 120H229C226.791 120 225 118.209 225 116V30Z",
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 4C225 1.79086 226.791 0 229 0H281C283.209 0 285 1.79086 285 4V30H225V4Z",
    fill: "#4B2CE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_15145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_316_15145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white",
    transform: "translate(75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_316_15145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white",
    transform: "translate(150)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_316_15145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 120,
    fill: "white",
    transform: "translate(225)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstantAmortization);
export default __webpack_public_path__ + "static/media/constant_amortization.47ded8d350a892c4b9bf31da920f3fb4.svg";
export { ForwardRef as ReactComponent };